import { graphqlRequest } from '../graphql/client';
import { CREATE_USER_MUTATION, DELETE_USER_MUTATION, UPDATE_USER_MUTATION, USERS_QUERY } from '../graphql/documents';
import type { ManagedUser } from './roles';
import type { UserRole } from '../data/types';

interface UsersResponse {
  users: ManagedUser[];
}

interface CreateUserResponse {
  createUser: ManagedUser;
}

interface UpdateUserResponse {
  updateUser: ManagedUser;
}

interface DeleteUserResponse {
  deleteUser: ManagedUser;
}

export async function fetchUsers(): Promise<ManagedUser[]> {
  const data = await graphqlRequest<UsersResponse>(USERS_QUERY);
  return data.users;
}

export async function createUser(input: {
  email: string;
  displayName: string;
  password: string;
  pin: string;
  isActive: boolean;
  role: UserRole;
}): Promise<ManagedUser> {
  const data = await graphqlRequest<CreateUserResponse>(CREATE_USER_MUTATION, { input });
  return data.createUser;
}

export async function updateUser(input: {
  id: string;
  email: string;
  displayName: string;
  password?: string;
  pin?: string;
  isActive: boolean;
  role: UserRole;
}): Promise<ManagedUser> {
  const data = await graphqlRequest<UpdateUserResponse>(UPDATE_USER_MUTATION, { input });
  return data.updateUser;
}

export async function deleteUser(id: string): Promise<ManagedUser> {
  const data = await graphqlRequest<DeleteUserResponse>(DELETE_USER_MUTATION, { id });
  return data.deleteUser;
}
